const issueFields = [
  {
    id: "book_id",
    numeric: true,
    disablePadding: false,
    label: "Book Id",
    width: "auto",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    width: "300px",
  },
  {
    id: "author",
    numeric: false,
    disablePadding: false,
    label: "Author",
    width: "300px",
  },
  {
    id: "userid",
    numeric: true,
    disablePadding: false,
    label: "User Id",
    width: "auto",
  },
  {
    id: "issued_date",
    numeric: true,
    disablePadding: false,
    label: "Issue Date",
    width: "80px",
    type: "date",
  },
  {
    id: "user_name",
    numeric: false,
    disablePadding: false,
    label: "Issued To",
    width: "200px",
  },
  {
    id: "renew_date",
    numeric: true,
    disablePadding: false,
    label: "Renew Date",
    width: "80px",
    type: "date",
  },
  {
    id: "return_date",
    numeric: true,
    disablePadding: false,
    label: "Return Date",
    width: "80px",
    type: "date",
  },
  {
    id: "issuedByName",
    numeric: false,
    disablePadding: false,
    label: "Issued By",
    width: "auto",
  },
  {
    id: "returnByName",
    numeric: false,
    disablePadding: false,
    label: "Return By",
    width: "auto",
  },
];

export default issueFields;
